/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DesignProfileStatus = "ACTIVE" | "DELETED" | "NEW" | "PENDING" | "%future added value";
export type ProgressTour_tradeFirm = {
    readonly serviceId: string | null;
    readonly profileStatus: DesignProfileStatus | null;
    readonly publicProfile: {
        readonly about: string | null;
        readonly splashPhoto: string | null;
        readonly profilePhoto: string | null;
        readonly designProjectsCover: ReadonlyArray<{
            readonly status: string | null;
        } | null> | null;
        readonly address: {
            readonly zipCode: string | null;
            readonly country: string | null;
        } | null;
        readonly email: string | null;
        readonly portfolios: ReadonlyArray<{
            readonly serviceId: string | null;
        } | null> | null;
    } | null;
    readonly " $refType": "ProgressTour_tradeFirm";
};
export type ProgressTour_tradeFirm$data = ProgressTour_tradeFirm;
export type ProgressTour_tradeFirm$key = {
    readonly " $data"?: ProgressTour_tradeFirm$data;
    readonly " $fragmentRefs": FragmentRefs<"ProgressTour_tradeFirm">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProgressTour_tradeFirm",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeFirmPublicProfileType",
      "kind": "LinkedField",
      "name": "publicProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "about",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "splashPhoto",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "profilePhoto",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DesignProjectCover",
          "kind": "LinkedField",
          "name": "designProjectsCover",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "address",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "zipCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "country",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PortfolioV1",
          "kind": "LinkedField",
          "name": "portfolios",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TradeFirmType",
  "abstractKey": null
};
})();
(node as any).hash = '3ca728a54f14a32400fbab3487ef50ca';
export default node;
